const crowdType = [
    {
        label: '我的style',
        children: [{
            value: '63',
            label: '街头少女',
        },{
            value: '61',
            label: '帅气BF风',
        },{
            value: '56',
            label: '清新森女',
        },{
            value: '57',
            label: '就爱设计感',
        },{
            value: '55',
            label: '青春学院风',
        },{
            value: '52',
            label: '性感尤物',
        },{
            value: '51',
            label: '气质名媛',
        },{
            value: '48',
            label: '时髦小妖精',
        },{
            value: '47',
            label: '欧美范儿',
        },{
            value: '1275',
            label: '港风男女',
        },{
            value: '1268',
            label: '极简主义',
        },{
            value: '1162',
            label: '就爱宽松感',
        },{
            value: '1157',
            label: '民族风',
        },{
            value: '1197',
            label: '小小的我',
        },{
            value: '1317',
            label: '海派甜心',
        },{
            value: '394',
            label: '复古女郎',
        }]
    },
    {
        label: 'geek怪才',
        children: [{
            label: '耳机发烧友',
            value: '76'
        },{
            label: '游戏外设迷',
            value: '22'
        },{
            label: '炫酷极客控',
            value: '6'
        },{
            label: '摄影发烧友',
            value: '33'
        },{
            label: '电脑发烧友',
            value: '1308'
        },{
            label: '码农style',
            value: '391'
        },{
            label: '手机重患者',
            value: '898'
        }]
    },
    {
        label: '动起来',
        children: [{
            label: '酷跑一族',
            value: '31'
        },
        {
            label: '钓鱼翁',
            value: '20'
        },
        {
            label: '旅行家',
            value: '19'
        },
        {
            label: '健身狂人',
            value: '13'
        },
        {
            label: '登山爱好者',
            value: '38'
        },
        {
            label: '骑行控',
            value: '39'
        },
        {
            label: '足球爱好者',
            value: '36'
        },
        {
            label: '超强灌篮手',
            value: '35'
        },
        {
            label: '滑板少年',
            value: '1240'
        },
        {
            label: '轮滑社',
            value: '1241'
        },
        {
            label: '棒球小子',
            value: '1227'
        },
        {
            label: '极限挑战控',
            value: '1259'
        },
        {
            label: '爱上高尔夫',
            value: '1251'
        },
        {
            label: '乒乓小将',
            value: '1176'
        },
        {
            label: '滑雪族',
            value: '1174'
        },
        {
            label: '棋牌社',
            value: '1175'
        },
        {
            label: '攀岩主义',
            value: '1172'
        },
        {
            label: '灵魂冲浪手',
            value: '1173'
        },
        {
            label: '羽球小子',
            value: '1170'
        },
        {
            label: '瑜伽修炼者',
            value: '1171'
        },
        {
            label: '天文爱好者',
            value: '1169'
        },
        {
            label: '户外运动控',
            value: '1164'
        },
        {
            label: '水中飞鱼',
            value: '1163'
        },
        {
            label: '网球小子',
            value: '1214'
        },
        {
            label: '想要瘦瘦瘦',
            value: '393'
        }]
    },
    {
        label: '有意思的人生',
        children: [{
            label: '就送咱爸妈',
            value: '1145'
        },
        {
            label: '女神范',
            value: '1142'
        },
        {
            label: '就爱大叔范',
            value: '16'
        },
        {
            label: '男神style',
            value: '8'
        },
        {
            label: '豆蔻少女',
            value: '9'
        },
        {
            label: '新时代主妇',
            value: '1'
        },
        {
            label: '职场白骨精',
            value: '1229'
        },
        {
            label: '制服党',
            value: '1258'
        },
        {
            label: '超级大学生',
            value: '1166'
        },
        {
            label: '请嫁给我吧',
            value: '1165'
        },
        {
            label: '这小子真帅',
            value: '1215'
        },
        {
            label: '丈母娘最爱',
            value: '1212'
        },
        {
            label: '文艺青年',
            value: '1198'
        },
        {
            label: '华丽上班族',
            value: '1185'
        }]
    },
    {
        label: '剁手俱乐部',
        children: [{
            label: '手表控',
            value: '75'
        },
        {
            label: '包治百病',
            value: '66'
        },
        {
            label: '美帽的你',
            value: '67'
        },
        {
            label: '香氛控',
            value: '27'
        },
        {
            label: '月光族福音',
            value: '1180'
        },
        {
            label: '美鞋控',
            value: '1158'
        },
        {
            label: '潮鞋宠儿',
            value: '1159'
        },
        {
            label: '超级买手',
            value: '1204'
        },
        {
            label: '爱国主义',
            value: '1201'
        },
        {
            label: '绝饰佳人',
            value: '388'
        }]
    },
    {
        label: '生活美学',
        children: [{
            label: '轻微萌物癖',
            value: '70'
        },
        {
            label: 'DIY达人',
            value: '28'
        },
        {
            label: '雅致居家控',
            value: '29'
        },
        {
            label: '绿植控',
            value: '25'
        },
        {
            label: '囤货小当家',
            value: '4'
        },
        {
            label: '理想家',
            value: '5'
        },
        {
            label: '品为家',
            value: '1217'
        },
        {
            label: '工业风的家',
            value: '1262'
        },
        {
            label: '早餐君',
            value: '1182'
        },
        {
            label: '抗霾卫士',
            value: '1181'
        },
        {
            label: '中式贵族',
            value: '1210'
        },
        {
            label: '美式家',
            value: '1211'
        },
        {
            label: '钟情北欧风',
            value: '1208'
        },
        {
            label: '木作匠人',
            value: '380'
        },
        {
            label: '杯子控',
            value: '381'
        },
        {
            label: '赖床专业户',
            value: '378'
        },
        {
            label: '古典匠人',
            value: '1302'
        },
        {
            label: '智慧家',
            value: '1320'
        },
        {
            label: '租房一族',
            value: '1022'
        },
        {
            label: '手工匠人',
            value: '1000'
        },
        {
            label: '多肉控',
            value: '398'
        },
        {
            label: '盘子控',
            value: '387'
        },
        {
            label: '文玩控',
            value: '385'
        },
        {
            label: '装修家',
            value: '930'
        }]
    },
    {
        label: '我要美美哒',
        children: [{
            label: '欧美妆容控',
            value: '1242'
        },
        {
            label: '干皮星人',
            value: '1266'
        },
        {
            label: '油皮星人',
            value: '1264'
        },
        {
            label: '素颜女神',
            value: '1265'
        },
        {
            label: '美发达人',
            value: '1263'
        },
        {
            label: '日系美妆控',
            value: '1160'
        },
        {
            label: '医美一族',
            value: '1209'
        },
        {
            label: '美妆达人',
            value: '377'
        },
        {
            label: '黑皮星人',
            value: '1307'
        },
        {
            label: '黑眼圈星人',
            value: '1304'
        },
        {
            label: '美体师',
            value: '1299'
        },
        {
            label: '口红控',
            value: '1295'
        },
        {
            label: '月球代言人',
            value: '1284'
        }]
    },
    {
        label: '文艺范儿',
        children: [{
            label: '我要当学霸',
            value: '78'
        },
        {
            label: '绘画一族',
            value: '21'
        },
        {
            label: '吉他控',
            value: '40'
        },
        {
            label: '都是好集友',
            value: '37'
        },
        {
            label: '挥毫泼墨派',
            value: '34'
        },
        {
            label: '漫画迷',
            value: '1226'
        },
        {
            label: '历史狂享家',
            value: '1224'
        },
        {
            label: '哲学家',
            value: '1219'
        },
        {
            label: '意气书生',
            value: '1179'
        },
        {
            label: '陶艺大师',
            value: '1306'
        },
        {
            label: '彩绘师',
            value: '1305'
        },
        {
            label: '就是爱乐人',
            value: '1017'
        }]
    },
    {
        label: '怪有意思的',
        children: [{
            label: '好想谈恋爱',
            value: '1151'
        },
        {
            label: '汪星人',
            value: '1140'
        },
        {
            label: '水族爱好者',
            value: '1141'
        },
        {
            label: '模型控',
            value: '24'
        },
        {
            label: '萌宠大作战',
            value: '17'
        },
        {
            label: '二次元达人',
            value: '14'
        },
        {
            label: '大脸星人',
            value: '1245'
        },
        {
            label: '家有煮妇',
            value: '1272'
        },
        {
            label: '洛丽塔少女',
            value: '1248'
        },
        {
            label: '喵星人',
            value: '1168'
        },
        {
            label: '爱车一族',
            value: '1161'
        },
        {
            label: '温暖小贴士',
            value: '1155'
        },
        {
            label: '怕冷星人',
            value: '1184'
        },
        {
            label: '占卜师',
            value: '1310'
        },
        {
            label: '速记师',
            value: '1303'
        },
        {
            label: '中医世家',
            value: '1316'
        },
        {
            label: '趣玩先锋',
            value: '1013'
        },
        {
            label: 'COS巨巨',
            value: '896'
        }]
    },
    {
        label: '换个角色吧',
        children: [{
            label: '单身汪汪汪',
            value: '12'
        },
        {
            label: '轻食主义',
            value: '1260'
        },
        {
            label: '厨艺达人',
            value: '1256'
        },
        {
            label: 'office病患者',
            value: '1255'
        },
        {
            label: '我就是大',
            value: '895'
        },
        {
            label: '晚睡强迫症',
            value: '876'
        },
        {
            label: '痛经忍者',
            value: '877'
        },
        {
            label: '拼命十三郎',
            value: '874'
        },
        {
            label: '懒癌患者',
            value: '875'
        },
        {
            label: '妙手仁心',
            value: '1311'
        },
        {
            label: '粘土人',
            value: '1300'
        },
        {
            label: '我勒个趣',
            value: '1301'
        },
        {
            label: '嘻哈一族',
            value: '1286'
        },
        {
            label: 'Party党',
            value: '775'
        },
        {
            label: '毛驴党',
            value: '1314'
        },
        {
            label: '整蛊王',
            value: '1315'
        },
        {
            label: 'ps大师',
            value: '1312'
        },
        {
            label: '收纳控',
            value: '1020'
        },
        {
            label: '追星族',
            value: '908'
        },
        {
            label: '敏感的我',
            value: '899'
        },
        {
            label: '太平公主',
            value: '897'
        }]
    },
    {
        label: '吃货集中营',
        children: [{
            label: '水果大咖',
            value: '636'
        },
        {
            label: '烘焙爱好者',
            value: '634'
        },
        {
            label: '品酒大师',
            value: '635'
        },
        {
            label: '火锅爱好者',
            value: '632'
        },
        {
            label: '养生达人',
            value: '518'
        },
        {
            label: '红酒达人',
            value: '517'
        },
        {
            label: '就爱吃甜食',
            value: '1261'
        },
        {
            label: '奶茶妹妹',
            value: '1309'
        },
        {
            label: '我是美食家',
            value: '1319'
        },
        {
            label: '吃货的后裔',
            value: '1019'
        },
        {
            label: '吃不胖星人',
            value: '494'
        },
        {
            label: '肉食者阵地',
            value: '492'
        },
        {
            label: '茶道中人',
            value: '493'
        },
        {
            label: '重口味星人',
            value: '490'
        },
        {
            label: '就爱吃点酸',
            value: '491'
        },
        {
            label: '无辣不欢者',
            value: '489'
        },
        {
            label: '芝士脑残粉',
            value: '399'
        },
        {
            label: '咖啡控',
            value: '900'
        }]
    },
    {
        label: '我家宝贝萌萌哒',
        children: [{
            label: '小小工程师',
            value: '1246'
        },
        {
            label: '小小画家',
            value: '1244'
        },
        {
            label: '萌宝逛世界',
            value: '1238'
        },
        {
            label: '小小舞者',
            value: '1239'
        },
        {
            label: '天才科学家',
            value: '1236'
        },
        {
            label: '小小赛车手',
            value: '1237'
        },
        {
            label: '小小运动员',
            value: '1235'
        },
        {
            label: '小小二次元',
            value: '1233'
        },
        {
            label: '小小军事迷',
            value: '1225'
        },
        {
            label: '芭比收藏家',
            value: '1222'
        },
        {
            label: '迷恋迪士尼',
            value: '1223'
        },
        {
            label: '职场辣妈',
            value: '1220'
        },
        {
            label: '家有双胞胎',
            value: '1221'
        },
        {
            label: '月子女王',
            value: '1218'
        },
        {
            label: '宝宝营养师',
            value: '1216'
        },
        {
            label: '独立小萌宝',
            value: '1279'
        },
        {
            label: '宝宝护理师',
            value: '1257'
        },
        {
            label: '萌宝学院',
            value: '1206'
        },
        {
            label: '家有小学生',
            value: '1207'
        },
        {
            label: '小小厨师',
            value: '1205'
        },
        {
            label: '海派妈咪',
            value: '1203'
        },
        {
            label: '小小公主范',
            value: '1200'
        },
        {
            label: '小正太',
            value: '1199'
        },
        {
            label: '小小贵族范',
            value: '1196'
        },
        {
            label: '好孕妈咪帮',
            value: '873'
        },
        {
            label: '家有萌娃',
            value: '871'
        },
        {
            label: '小小摄影师',
            value: '1294'
        },
        {
            label: '早教专家',
            value: '1292'
        },
        {
            label: '备孕妈咪',
            value: '1293'
        },
        {
            label: '萌宝游乐园',
            value: '1291'
        },
        {
            label: '小小钢琴家',
            value: '1282'
        },
        {
            label: '我是小医生',
            value: '1283'
        },
        {
            label: '亲子合家欢',
            value: '1280'
        },
        {
            label: '新生萌宝',
            value: '1281'
        }]
    },
    {
        label: '豪门俱乐部',
        children: [{
            label: '高富帅',
            value: '1150'
        },{
            label: '白富美',
            value: '1149'
        },{
            label: 'SVIP壕',
            value: '1147'
        },{
            label: '改装发烧友',
            value: '1144'
        },{
            label: '轻奢一族',
            value: '1230'
        },{
            label: '华尔街精英',
            value: '1228'
        },{
            label: '维密天使',
            value: '1267'
        },{
            label: '就爱限量版',
            value: '776'
        }]
    },
    {
        label: '总有你爱的元素',
        children: [{
            label: '中国有国潮',
            value: '1247'
        },
        {
            label: '非黑即白',
            value: '1274'
        },
        {
            label: '粉红少女心',
            value: '1273'
        },
        {
            label: '牛仔很潮',
            value: '1270'
        },
        {
            label: '撞色控',
            value: '1269'
        },
        {
            label: '格子控',
            value: '1254'
        },
        {
            label: '流苏控',
            value: '1252'
        },
        {
            label: '条纹控',
            value: '1253'
        },
        {
            label: '就是卫衣控',
            value: '1249'
        },
        {
            label: 'Bling控',
            value: '1296'
        },
        {
            label: 'ins达人',
            value: '1290'
        },
        {
            label: 'chic少女',
            value: '1288'
        },
        {
            label: 'ulzzang风',
            value: '1289'
        },
        {
            label: '波点控',
            value: '1287'
        },
        {
            label: '豹纹女王',
            value: '927'
        },
        {
            label: '蕾丝控',
            value: '914'
        },
        {
            label: '裙控MM',
            value: '389'
        },
        {
            label: '旗袍女子',
            value: '384'
        }]
    },
    {
        label: '那小子真帅',
        children: [{
            label: '潮男俱乐部',
            value: '80'
        },{
            label: '欧美型男',
            value: '72'
        },
        {
            label: '原宿少年',
            value: '1278'
        },
        {
            label: '不撞衫星人',
            value: '1276'
        },
        {
            label: '英伦也很帅',
            value: '1277'
        },
        {
            label: '摇滚朋克风',
            value: '1271'
        },
        {
            label: '大码界男神',
            value: '1183'
        },
        {
            label: '硬汉军旅风',
            value: '1285'
        },
        {
            label: '机车骑士',
            value: '1313'
        },
        {
            label: '清新暖男',
            value: '396'
        },
        {
            label: '韩范欧巴',
            value: '397'
        },
        {
            label: '国风男',
            value: '395'
        }]
    }
]

export {
    crowdType
}